var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { content: true, mobile: _vm.isMobile(_vm.$mq) } },
    [
      _c(
        "button",
        {
          directives: [
            {
              name: "track",
              rawName: "v-track:click",
              value: { axId: "clicked_groupsales_modal_back" },
              expression: "{ axId: 'clicked_groupsales_modal_back' }",
              arg: "click"
            }
          ],
          staticClass: "back-button btn-link",
          on: {
            click: function($event) {
              return _vm.handleBack()
            }
          }
        },
        [
          _c("span", { staticClass: "b-sprite-paywall-chevron" }),
          _vm._v("\n    Back\n  ")
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          directives: [
            {
              name: "track",
              rawName: "v-track:click",
              value: { axId: "clicked_groupsales_modal_close_button" },
              expression: "{ axId: 'clicked_groupsales_modal_close_button' }",
              arg: "click"
            }
          ],
          staticClass: "close btn-link",
          attrs: { "aria-label": "Close" },
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [_c("span", { staticClass: "b-sprite-global-close-black" })]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade-fast", mode: "out-in" } }, [
        _vm.step === "choose-group-type"
          ? _c(
              "div",
              { key: "choose-group-type", staticClass: "choose-group-type" },
              [
                _c("GroupPaywallIllustration"),
                _vm._v(" "),
                _c("h2", [_vm._v("What sort of group are you?")]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "unstyled" },
                  _vm._l(_vm.group_types, function(group) {
                    return _c("li", { key: group }, [
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "track",
                              rawName: "v-track:click",
                              value: {
                                axId: "clicked_groupsales_modal_choose_group",
                                axExtra: { premium_group_type: group }
                              },
                              expression:
                                "{\n              axId: 'clicked_groupsales_modal_choose_group',\n              axExtra: { premium_group_type: group },\n            }",
                              arg: "click"
                            }
                          ],
                          staticClass: "btn-round",
                          on: {
                            click: function($event) {
                              return _vm.handleChooseGroupType(group)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " + _vm._s(group) + "\n          "
                          )
                        ]
                      )
                    ])
                  }),
                  0
                )
              ],
              1
            )
          : _vm.step === "group-type-school"
          ? _c(
              "div",
              { key: "group-type-school", staticClass: "group-type-school" },
              [
                _c("h2", [_vm._v("Are you an Educator?")]),
                _vm._v(" "),
                _c(
                  "p",
                  [
                    _vm._v(
                      "\n        If you’re an educator and would like access to Brilliant for your students,\n        "
                    ),
                    _c(
                      "router-link",
                      {
                        directives: [
                          {
                            name: "track",
                            rawName: "v-track:click",
                            value: {
                              axId:
                                "clicked_educators_account_from_group_plans",
                              axType: "button"
                            },
                            expression:
                              "{\n            axId: 'clicked_educators_account_from_group_plans',\n            axType: 'button',\n          }",
                            arg: "click"
                          }
                        ],
                        attrs: { to: { name: "teacher_landing" } }
                      },
                      [_vm._v("\n          apply for a free Education plan ")]
                    ),
                    _vm._v(
                      ". You’ll be able to bring Brilliant into your in-person or remote classroom and access\n        interactive lessons, problem solving, classroom tools, and more.\n      "
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "If you aren’t an educator, our group plans are perfect for small groups."
                  )
                ]),
                _vm._v(" "),
                _c(
                  "footer",
                  [
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "track",
                            rawName: "v-track:click",
                            value: {
                              axId:
                                "clicked_continue_group_purchase_from_school_group"
                            },
                            expression:
                              "{ axId: 'clicked_continue_group_purchase_from_school_group' }",
                            arg: "click"
                          }
                        ],
                        staticClass: "btn btn-secondary",
                        on: {
                          click: function($event) {
                            _vm.step = "choose-seats"
                          }
                        }
                      },
                      [_vm._v("\n          Purchase a group plan\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        directives: [
                          {
                            name: "track",
                            rawName: "v-track:click",
                            value: {
                              axId:
                                "clicked_educators_account_from_group_plans",
                              axType: "button"
                            },
                            expression:
                              "{\n            axId: 'clicked_educators_account_from_group_plans',\n            axType: 'button',\n          }",
                            arg: "click"
                          }
                        ],
                        staticClass: "btn btn-primary",
                        attrs: { to: { name: "teacher_landing" } }
                      },
                      [
                        _vm._v(
                          "\n          Apply for an educator's account\n        "
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          : _vm.step === "choose-seats"
          ? _c("div", { key: "choose-seats", staticClass: "choose-seats" }, [
              _c("header", [
                _c("h2", [
                  _vm._v("How many seats "),
                  _c("span", { staticClass: "nowrap" }, [
                    _vm._v("would you like")
                  ]),
                  _vm._v("?")
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.baseNumSeats) +
                      " seats for " +
                      _vm._s(_vm.monthlyPriceMinimumSeats.for_display) +
                      "/month\n          "
                  ),
                  _c("span", { staticClass: "nowrap" }, [
                    _vm._v(
                      "\n            + " +
                        _vm._s(_vm.monthlyPriceAdditionalSeat.for_display) +
                        "/month for each extra seat\n          "
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "chooser" }, [
                _c("h3", [_vm._v("Number of seats")]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "button",
                    {
                      attrs: {
                        disabled: _vm.numSeats === _vm.seatCountMinimum
                      },
                      on: {
                        click: function($event) {
                          return _vm.updateSeats(-1)
                        }
                      }
                    },
                    [_c("span", [_vm._v("–")])]
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.numSeats))]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      attrs: {
                        disabled: _vm.numSeats === _vm.seatCountMaximum
                      },
                      on: {
                        click: function($event) {
                          return _vm.updateSeats(1)
                        }
                      }
                    },
                    [_c("span", [_vm._v("+")])]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "checkout-button" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-green",
                    on: {
                      click: function($event) {
                        return _vm.handleSubscribe()
                      }
                    }
                  },
                  [
                    _c(
                      "transition",
                      { attrs: { name: "fade-fast", mode: "out-in" } },
                      [
                        _vm.loadingPurchaseOrder
                          ? _c("LoadingAnimation", {
                              staticClass: "loading",
                              attrs: {
                                type: "dots",
                                color: "light",
                                size: "small"
                              }
                            })
                          : _c("span", [_c("span", [_vm._v("Subscribe")])])
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "footer",
                [
                  _c(
                    "transition",
                    { attrs: { name: "fade-fast", mode: "out-in" } },
                    [
                      !_vm.showPricingTable
                        ? _c("p", [
                            _c("strong", [
                              _vm._v("Annual Premium group total:")
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "nowrap" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.totalPrice) +
                                  "\n              "
                              ),
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "track",
                                      rawName: "v-track:click",
                                      value: {
                                        uxId:
                                          "clicked_groupsales_modal_show_pricing_table"
                                      },
                                      expression:
                                        "{ uxId: 'clicked_groupsales_modal_show_pricing_table' }",
                                      arg: "click"
                                    }
                                  ],
                                  staticClass: "btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.showPricingTable = true
                                    }
                                  }
                                },
                                [_c("span", { staticClass: "arrow small" })]
                              )
                            ])
                          ])
                        : _c("table", [
                            _c("tbody", [
                              _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.annualPriceMinimumSeats.for_display
                                    ) + " …"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                  Annual Brilliant Premium group plan"
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("em", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.monthlyPriceMinimumSeats
                                            .for_display
                                        ) +
                                        "/month for up to\n                    " +
                                        _vm._s(_vm.seatCountMinimum) +
                                        " seats\n                  "
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _vm.numExtraSeats
                                ? _c("tr", [
                                    _c("td", [
                                      _vm._v(
                                        "\n                  + " +
                                          _vm._s(
                                            _vm.priceForNumSeats
                                              .annual_price_additional_seats
                                              .for_display
                                          ) +
                                          " …\n                "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.numExtraSeats) +
                                          " extra " +
                                          _vm._s(
                                            _vm.numExtraSeats === 1
                                              ? "seat"
                                              : "seats"
                                          )
                                      ),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("em", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.monthlyPriceAdditionalSeat
                                              .for_display
                                          ) + "/month for each extra seat"
                                        )
                                      ])
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.previousSubscription
                                ? _c("tr", [
                                    _c("td", [
                                      _vm._v(
                                        "- " +
                                          _vm._s(
                                            _vm.previousSubscription.credit
                                              .for_display
                                          ) +
                                          " …"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        "\n                  Credit for your Premium payment on " +
                                          _vm._s(_vm.previousSubscriptionDate)
                                      ),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("em", [
                                        _vm._v(
                                          "\n                    Prorated for the additional\n                    " +
                                            _vm._s(
                                              _vm.previousSubscription
                                                .remaining_months
                                            ) +
                                            "\n                    " +
                                            _vm._s(
                                              _vm.previousSubscription
                                                .remaining_months === 1
                                                ? "month"
                                                : "months"
                                            ) +
                                            "\n                  "
                                        )
                                      ])
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("tr", [
                                _c("td", [
                                  _vm._v(_vm._s(_vm.totalPrice) + " …")
                                ]),
                                _vm._v(" "),
                                _c("td", [_vm._v("What you pay today")])
                              ])
                            ])
                          ])
                    ]
                  )
                ],
                1
              )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }